import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInputPassword = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 13,
	viewBox: "0 0 14 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 1.5H5C4.72386 1.5 4.5 1.72386 4.5 2V4H9.5V2C9.5 1.72386 9.27614 1.5 9 1.5ZM11 4H12C13.1046 4 14 4.89543 14 6V11C14 12.1046 13.1046 13 12 13H2C0.89543 13 0 12.1046 0 11V6C0 4.89543 0.895431 4 2 4H3V2C3 0.89543 3.89543 0 5 0H9C10.1046 0 11 0.895431 11 2V4ZM2 5.5H12C12.2761 5.5 12.5 5.72386 12.5 6V11C12.5 11.2761 12.2761 11.5 12 11.5H2C1.72386 11.5 1.5 11.2761 1.5 11V6C1.5 5.72386 1.72386 5.5 2 5.5Z",
		fill: "black"
	})
});
export default SvgInputPassword;
